// Accordion functionality for FAQ/Terms sections using o-accordion classes
(function() {
  // Mark that JavaScript is enabled for progressive enhancement
  // The theme.liquid already adds 'js' class, we'll use that
  if (!document.documentElement.classList.contains('js-enabled')) {
    document.documentElement.classList.add('js-enabled');
  }
  
  function initAccordions() {
    const accordionContainers = document.querySelectorAll('[data-accordion]');
    
    accordionContainers.forEach(container => {
      // Skip if already initialized
      if (container.dataset.accordionInitialized === 'true') return;
      container.dataset.accordionInitialized = 'true';
      
      const accordionSlides = container.querySelectorAll('[data-accordion-slide]');
      
      accordionSlides.forEach(slide => {
        const title = slide.querySelector('[data-accordion-title]');
        const body = slide.querySelector('[data-accordion-body]');
        
        if (!title || !body) return;
        
        // Make title clickable
        title.style.cursor = 'pointer';
        title.setAttribute('role', 'button');
        title.setAttribute('tabindex', '0');
        title.setAttribute('aria-expanded', 'false');
        
        // Hide body using CSS class (progressive enhancement)
        // Content is visible by default for SEO, hidden when JS runs
        if (!body.classList.contains('accordion-initialized')) {
          // Remove any inline styles that might interfere
          body.style.display = '';
          body.style.overflow = '';
          body.style.maxHeight = '';
          body.style.paddingTop = '';
          body.style.paddingBottom = '';
          // Add class to mark as initialized - CSS will handle hiding
          body.classList.add('accordion-initialized');
          // Ensure it's hidden via CSS class
          if (!slide.classList.contains('is-expanded')) {
            body.classList.remove('is-expanded');
          }
        }
        
        // Toggle function
        const toggleAccordion = (e) => {
          if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
            return;
          }
          if (e.type === 'keydown') {
            e.preventDefault();
          }
          
          const isExpanded = title.getAttribute('aria-expanded') === 'true';
          const newState = !isExpanded;
          
          title.setAttribute('aria-expanded', newState.toString());
          slide.classList.toggle('is-expanded', newState);
          
          if (newState) {
            // Open - use class-based approach for better CSS control
            body.classList.add('is-expanded');
            slide.classList.add('is-expanded');
            // Force reflow for smooth animation
            body.offsetHeight;
            // Remove inline styles, let CSS handle it
            body.style.display = '';
            body.style.maxHeight = '';
            body.style.paddingTop = '';
            body.style.paddingBottom = '';
          } else {
            // Close - use class-based approach
            body.classList.remove('is-expanded');
            slide.classList.remove('is-expanded');
            // Let CSS handle the transition
            body.style.display = '';
            body.style.maxHeight = '';
            body.style.paddingTop = '';
            body.style.paddingBottom = '';
          }
        };
        
        // Add event listeners
        title.addEventListener('click', toggleAccordion);
        title.addEventListener('keydown', toggleAccordion);
      });
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }
  
  // Re-initialize for dynamically loaded content
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAccordions);
  }
})();

